var fitGuideImageSlider = class extends HTMLElement {
  constructor() {
    super();
    this.measurementsArray = [];
    this.loadSlider();
  }

  setMeasurementsData(measurementsArray) {
    this.measurementsArray = measurementsArray || [];
  }

  loadSlider() {
    const sliderContainer = this.querySelector('.fit-guide-image-slider');

    if (sliderContainer && !sliderContainer.classList.contains('swiper-initialized')) {
      const prevEl = this.querySelector('.swiper-button-prev');
      const nextEl = this.querySelector('.swiper-button-next');

      const swiper = new Swiper(sliderContainer, {
        slidesPerView: 1,
        loop: false,
        spaceBetween: 0,
        navigation: {
          prevEl,
          nextEl,
        },
        on: {
          init: (swiper) => {
            this.handleVideoPlayback(swiper);
            this.updateMeasurementsText(swiper);
          },
          slideChange: (swiper) => {
            this.handleVideoPlayback(swiper);
            this.updateMeasurementsText(swiper);
          },
        },
      });

      // Store swiper instance for later use
      this.swiperInstance = swiper;
      sliderContainer.classList.add('swiper-initialized');
    }
  }

  handleVideoPlayback(swiper) {
    // Pause all videos
    const allVideos = swiper.el.querySelectorAll('video');
    allVideos.forEach((video) => {
      video.pause();
      video.currentTime = 0;
    });

    // Play video in active slide
    const activeSlide = swiper.slides[swiper.activeIndex];
    const video = activeSlide?.querySelector('video');
    if (video) {
      video.play().catch((err) => console.warn('Video autoplay failed:', err));
    }
  }

  updateMeasurementsText(swiper) {
    const measurementsElement = document.getElementById('measurements_text_print');
    if (measurementsElement && this.measurementsArray.length > 0) {
      const activeIndex = swiper.activeIndex;
      
      // Check if there's specific text for the current slide
      const measurementText = this.measurementsArray[activeIndex];
      
      if (measurementText && measurementText.trim() !== "") {
        // Show text if it exists for current slide
        measurementsElement.textContent = measurementText;
        measurementsElement.style.display = 'block';
      } else {
        // Hide text if no specific text for current slide
        measurementsElement.textContent = "";
        measurementsElement.style.display = 'none';
      }
    } else {
      // Hide if no measurements array
      if (measurementsElement) {
        measurementsElement.textContent = "";
        measurementsElement.style.display = 'none';
      }
    }
  }
}

customElements.define('fit-guide-image-slider', fitGuideImageSlider);


// Function to handle main category tabbing
document.querySelectorAll('.main-cat li').forEach(item => {
  item.addEventListener('click', function() {
    const selectedCat = this.getAttribute('data-cat');
    document.querySelectorAll('.main-cat li').forEach(cat => {
      cat.classList.remove('active-cat');
      cat.classList.remove("text-white", "bg-black");
    });
    this.classList.add('active-cat');
    this.classList.add("text-white", "bg-black");
    document.querySelectorAll('.main-cat-content').forEach(content => {
      content.style.display = 'none';
    });
    document.querySelector(`[data-cat-content="${selectedCat}"]`).style.display = 'block';
    const firstSubcat = document.querySelector(`[data-cat-content="${selectedCat}"] .sub-cat li`);
    if (firstSubcat) {
      firstSubcat.click();
    }
  });
});

// Function to handle subcategory tabbing
document.querySelectorAll('.sub-cat li').forEach(item => {
  item.addEventListener('click', function() {
    const selectedSubcat = this.getAttribute('data-subcat');
    const parentContent = this.closest('.main-cat-content');
    parentContent.querySelectorAll('.sub-cat li').forEach(subcat => {
      subcat.classList.remove('active-subcat');
      subcat.classList.remove("border-black", "border-b-1");
    });
    this.classList.add('active-subcat');
    this.classList.add("border-black", "border-b-1");
    parentContent.querySelectorAll('.sub-cat-content').forEach(content => {
      content.style.display = 'none';
    });
    const selectedContent = parentContent.querySelector(`[data-subcat-content="${selectedSubcat}"]`);
    selectedContent.style.display = 'block';
    
    // Initialize Swipers and check for arrow enablement
    initSwipers(selectedContent);
  });
});

// Initialize: Show the first category and subcategory by default
document.querySelector('.main-cat li').click();

// Swiper initialization function with dynamic attributes
function initSwipers(content) {
  const thumbsContainer = content.querySelector('.gallery-thumbs');
  const thumbsContainerSlider = content.querySelector('.gallery-thumbs');
  const slideCount = thumbsContainer.querySelectorAll('.swiper-slide').length;

  // Skip initialization if slides are fewer than slidesPerView
  const minSlidesPerView = 2; // Adjust this value based on your configuration
  const breakpointsMinSlides = {
    640: 3,
    768: 4,
    1024: 6
  };

  let maxSlidesPerView = minSlidesPerView;
  Object.keys(breakpointsMinSlides).forEach(breakpoint => {
    if (window.innerWidth >= breakpoint) {
      maxSlidesPerView = breakpointsMinSlides[breakpoint];
    }
  });

  if (slideCount < maxSlidesPerView) {
    thumbsContainer.classList.add('no-slider'); // Add class for non-slider
  }

  // Gallery-Thumbs initialization
  const thumbsSwiper = new Swiper(thumbsContainerSlider, {
    spaceBetween: 10,
    slidesPerView: 2,
    freeMode: true,
    centeredSlides: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    allowTouchMove: true,
    loop: false,
    navigation: {
      nextEl: content.querySelector('.thumbs-button-next'),
      prevEl: content.querySelector('.thumbs-button-prev'),
    },
    breakpoints: {
      640: {
        slidesPerView: slideCount >= 3 ? 3 : slideCount,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: slideCount >= 4 ? 4 : slideCount,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: slideCount >= 6 ? 6 : slideCount,
        spaceBetween: 36,
      },
    },
  });

  // Enable/Disable navigation arrows based on the slide count
  if (slideCount > 1) {
    content.querySelector('.thumbs-button-next').style.display = 'flex';
    content.querySelector('.thumbs-button-prev').style.display = 'flex';
  } else {
    content.querySelector('.thumbs-button-next').style.display = 'none';
    content.querySelector('.thumbs-button-prev').style.display = 'none';
  }

  // Gallery-Top initialization with thumbs control
  new Swiper(content.querySelector('.gallery-top'), {
    loop: true,
    spaceBetween: 10,
    allowTouchMove: false,
    autoHeight: true,
    thumbs: {
      swiper: thumbsSwiper,
    },
  });
}

// Search Item START

// Utility function to escape HTML
function escapeHTML(str) {
  return str.replace(/[&<>"']/g, (match) => {
    const escapeChars = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    };
    return escapeChars[match];
  });
}

// Debounce function to optimize performance
function debounce(func, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
}

// Extract Fit Guide Titles, Images, and Details
const fitGuides = Array.from(document.querySelectorAll('#fg_title')).map((h2, index) => {
  const image = document.querySelectorAll('#fg_image')[index];
  const guideDetails = {
    title: h2.textContent.trim(),
    image: image ? image.src : '',
    featured_image: document.querySelectorAll('#fg_featured_image')[index]?.src || '',
    measurements_text: document.querySelectorAll('#fg_measurements_text')[index]?.textContent.trim() || '',
    coverage: document.querySelectorAll('#fg_coverage')[index]?.textContent.trim() || '',
    support: document.querySelectorAll('#fg_support')[index]?.textContent.trim() || '',
    rise: document.querySelectorAll('#fg_rise')[index]?.textContent.trim() || '',
    adjustable_band: document.querySelectorAll('#fg_adjustable_band')[index]?.textContent.trim() || '',
    adjustable_straps: document.querySelectorAll('#fg_adjustable_straps')[index]?.textContent.trim() || '',
    best_for: document.querySelectorAll('#fg_best_for')[index]?.textContent.trim() || '',
    sizing_tips: document.querySelectorAll('#fg_sizing_tips')[index]?.textContent.trim() || '',
  };
  return guideDetails;
});

const input = document.getElementById('searchInput');
const resultsContainer = document.getElementById('results');
const mainCategoryElement = document.getElementById('main-category');
const popup = document.querySelector('.result-item-popup');
const popupContent = document.querySelector('.popup-content');
const body = document.body;

async function getMetaobjects() {
  const query = `
  {
    metaobjects(type: "fit_guide", first: 100) {
      nodes {
        handle
        fields {
          key
          value
          reference {
            ... on MediaImage {
              image {
                url
              }
            }
            ... on Video {
              sources {
                url
              }
            }
          }
        }
      }
    }
  }
  `;

  try {
    const response = await fetch("https://skatie.com/api/2024-04/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": "22a01b5899e413a3af7cca864a2928b4"
      },
      body: JSON.stringify({ query })
    });

    const data = await response.json();
    
    if (data.errors) {
      console.error("GraphQL Errors:", data.errors);
      return [];
    }
    return data.data.metaobjects.nodes; // ✅ Now correctly returns metaobjects

  } catch (error) {
    console.error("Error fetching metaobjects:", error);
    return [];
  }
}

async function searchFitGuide(query) {
  const seen = new Set();
  let data = await getMetaobjects(); // Fetch metaobjects
  if (!data || !Array.isArray(data)) {
    console.error("Invalid data received:", data);
      return fitGuides
    .filter((item) => item.title.toLowerCase().includes(query.toLowerCase()))
    .filter((item) => {
      if (seen.has(item.title)) return false;
      seen.add(item.title);
      return true;
    });
  }

  return data?.filter(obj => {
    const titleField = obj?.fields?.find(field => field.key == "title");
    return titleField && titleField?.value.toLowerCase().includes(query?.toLowerCase());
  });
}


// Function to toggle visibility
function toggleVisibility(element, show) {
  element.style.display = show ? 'block' : 'none';
}

// Function to populate and open popup
function openPopup(data) {
  let titleField = data.fields.find((field) => field.key === "title")?.value || "N/A";
  let measurementsText = data.fields.find((field) => field.key === "measurements_text")?.value || "N/A";
  let coverageField = data.fields.find((field) => field.key === "coverage")?.value || "N/A";
  let supportField = data.fields.find((field) => field.key === "support")?.value || "N/A";
  let riseField = data.fields.find((field) => field.key === "rise")?.value || "N/A";
  let adjustableBand = data.fields.find((field) => field.key === "adjustable_band")?.value || "N/A";
  let adjustableStraps = data.fields.find((field) => field.key === "adjustable_straps")?.value || "N/A";
  let bestFor = data.fields.find((field) => field.key === "best_for")?.value || "N/A";
  let sizingTips = data.fields.find((field) => field.key === "sizing_tips")?.value || "N/A";
  let imageField = data.fields.find((field) => field.key === "featured_image");
  let videoField = data.fields.find((field) => field.key === "featured_video");
  let videoURL = videoField?.reference?.sources[0]?.url ? videoField.reference.sources[0].url : ""
  let imageUrl = imageField?.reference?.image?.url 
    ? `${imageField.reference.image.url}&width=600`  // Resize to 600px width
    : "";

  // Parse measurements text array
  let measurementsArray = [];
  try {
    measurementsArray = JSON.parse(measurementsText);
    // Ensure array has proper structure - filter out empty strings and convert to null
    measurementsArray = measurementsArray.map(text => text && text.trim() !== "" ? text.trim() : null);
  } catch (e) {
    console.warn('Could not parse measurements_text as JSON, using as string:', measurementsText);
    // Only add to array if it's not empty
    measurementsArray = measurementsText && measurementsText.trim() !== "" ? [measurementsText.trim()] : [null, null];
  }

  // Ensure we have at least 2 slots (for image and video slides)
  while (measurementsArray.length < 2) {
    measurementsArray.push(null);
  }

  console.log('videoField:: ',videoField);
  console.log('measurementsArray:: ', measurementsArray);

  try {
    document.getElementById('title_print').textContent = titleField;
    document.getElementById('featured_image_print').src = imageUrl;
    document.getElementById('coverage_print').textContent = coverageField;
    document.getElementById('support_print').textContent = supportField;
    document.getElementById('rise_print').textContent = riseField;
    document.getElementById('adjustable_band_print').textContent = adjustableBand;
    document.getElementById('adjustable_straps_print').textContent = adjustableStraps;
    document.getElementById('best_for_print').textContent = bestFor;
    document.getElementById('sizing_tips_print').textContent = sizingTips;

    // Initialize measurements text (will be updated by slider)
    const measurementsElement = document.getElementById('measurements_text_print');
    if (measurementsArray[0]) {
      measurementsElement.textContent = measurementsArray[0];
      measurementsElement.style.display = 'block';
    } else {
      measurementsElement.textContent = "";
      measurementsElement.style.display = 'none';
    }

    const videoSlide = popup.querySelector('.swiper-slide video')?.closest('.swiper-slide');

    if(videoField){
      const videoSource = document.getElementById('featured_video_source');
      videoSource.src = videoURL;
      document.getElementById('featured_video_print').load();
      if (videoSlide) videoSlide.style.display = 'block';
    } else {
      if (videoSlide) videoSlide.style.display = 'none'; // Hide video slide if no video
    }

    popup.style.display = 'flex'; // Show popup
    body.classList.add('overflow-hidden'); // Prevent scrolling

    const allSliders = popup.querySelectorAll('fit-guide-image-slider');
    allSliders.forEach(slider => {
      // Set measurements data before upgrading/loading
      if (typeof slider.setMeasurementsData === 'function') {
        slider.setMeasurementsData(measurementsArray);
      }
      
      customElements.upgrade(slider);
      if (typeof slider.loadSlider === 'function') {
        slider.loadSlider();
      }
      
      // Also set measurements data after upgrade in case the element wasn't upgraded before
      if (typeof slider.setMeasurementsData === 'function') {
        slider.setMeasurementsData(measurementsArray);
      }
    });
    
  } catch (error) {
    console.error('Error opening popup:', error);
  }
}

// Function to close popup
function closePopup() {
  popup.style.display = 'none'; // Hide popup
  body.classList.remove('overflow-hidden'); // Enable scrolling
}

function renderResultsHTML(results) {
  resultsContainer.innerHTML = results
    .map((item) => {
      const titleField = item.fields.find((field) => field.key === "title")?.value || "Unknown";
      const imageField = item.fields.find((field) => field.key === "thumbnail_image");
      const imageUrl = imageField?.reference?.image?.url 
        ? `${imageField.reference.image.url}&width=200`  // Resize to 200px width
        : "Unknown";

      
      return `
        <div 
          class="bg-white overflow-hidden cursor-pointer focus-visible:outline-none result-item"
          tabindex="0" 
          aria-label="Fit guide: ${titleField}"
          data-item='${JSON.stringify(item).replace(/'/g, "&#39;")}'
        >
          <div class="relative pb-full">
            <img src="${imageUrl}" alt="${titleField}"  sizes="100vw" class="w-full h-full absolute top-0 right-0 bottom-0 left-0 object-cover"/>
          </div>
          <div class="p-2">
            <h3 class="p-3 text-sm uppercase text-black">${titleField}</h3>
          </div>
        </div>
      `;
    })
    .join("");
}

// Function to render results in the grid
function renderResults(results) {
  try {
    // Reference the results container
    const resultsContainerClasses = resultsContainer.classList;

    if (results?.length === 0) {
      resultsContainer.innerHTML = `
        <div class="text-center col-span-full p-4">
          <p class="text-gray-500">No results found. Please try a different search term.</p>
        </div>
      `;

      // Remove grid classes when no results are found
      resultsContainerClasses.remove(
        'grid-cols-2',
        'sm:grid-cols-2',
        'md:grid-cols-3',
        'lg:grid-cols-4',
        'xxl:grid-cols-6'
      );

      toggleVisibility(mainCategoryElement, true); // Show main category
      return;
    }

    // Ensure the grid classes are added when there are results
    resultsContainerClasses.add(
      'grid-cols-2',
      'sm:grid-cols-2',
      'md:grid-cols-3',
      'lg:grid-cols-4',
      'xxl:grid-cols-6'
    );

    renderResultsHTML(results);
    toggleVisibility(mainCategoryElement, false); // Hide main category
  } catch (error) {
    console.error('Error rendering results:', error);
  }
}

// Event delegation for opening popup
resultsContainer.addEventListener('click', (e) => {
  const resultItem = e.target.closest('.result-item');
  if (resultItem) {
    const data = JSON.parse(resultItem.dataset.item);
    openPopup(data);
  }
});

// Attach close functionality to popup
document.querySelector('.popup-close').addEventListener('click', closePopup);

// Close popup when clicking outside of popup-content
popup.addEventListener('click', (e) => {
  if (!popupContent.contains(e.target)) {
    closePopup();
  }
});

// Close popup on ESC key press
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closePopup();
  }
});

// Event listener for search input
input.addEventListener(
  "input",
  debounce(async () => {
    const query = input.value.trim();
    if (query === "") {
      resultsContainer.innerHTML = "";
      toggleVisibility(mainCategoryElement, true); // Show main category
      return;
    }

    try {
      const results = await searchFitGuide(query);
      renderResults(results);
    } catch (error) {
      console.error("Error fetching results:", error);
    }
  }, 300)
);

// Search Item END